import React, { useState } from "react";
import { Modal, Button} from "react-bootstrap";

const VideoModal = ({ image, title, description, videoUrl, buttonText}) => {
  const [show, setShow] = useState(false);

  const handleModal = () => {
    setShow(!show);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div className="demovideo-inr">
      {/* Card-like layout */}
      <div 
        className="video-card" 
        onClick={handleModal} 
      >
        <div className="demovideo-img">
        <img 
          src={image} 
          alt={title} 
          style={{ width: "100%", borderRadius: "10px" }} 
        /></div>
        <div className="demovideo_title">
        <h5>{title}</h5>
       {buttonText && 
       <button>{buttonText}</button>
       }
       </div>
        <p>{description}</p>
      </div>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered size="lg">
      <div className="demo-modal">

        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="text-center">
          {videoUrl ? (
            <iframe
              width="100%"
              height="400"
              src={videoUrl}
              title={title}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="demovideo-img">
            <img 
              src={image} 
              alt={title} 
              style={{ width: "100%", borderRadius: "10px" }} 
            /></div>
          )}          
        </Modal.Body>
        <div className='demo-btn'>
                   <Button onClick={handleClose}>Close</Button>
                   </div>
        </div>
      </Modal>
    
    </div>
  );
};

export default VideoModal;
